module.exports = __webpack_public_path__ + "static/IronCAP logo white (480 x 110)-b738f1e4b822288579e2dcb63a9b39c1.png";